import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonIcon, IonInput, IonBackButton, IonNote, IonFooter, IonSpinner, IonButton, ModalController, IonButtons, IonSelect, IonSelectOption } from '@ionic/angular/standalone';
import { Group, GroupField, GroupPrivacyConsentUser } from 'src/app/app.types';
import CodiceFiscale from 'codice-fiscale-js'
import { addIcons } from 'ionicons';
import { alertCircle, checkmarkCircle, informationCircleOutline, closeOutline } from 'ionicons/icons';
import { Message } from "primeng/message"
import { ApiService } from 'src/app/api.service';
import { UserPrivacy } from 'src/app/auth-form/auth-form.page';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';

@Component({
  selector: 'app-auth-fields',
  templateUrl: './auth-fields.page.html',
  styleUrls: ['./auth-fields.page.scss'],
  standalone: true,
  imports: [IonButtons, IonNote, IonBackButton,
    CommonModule,
    FormsModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonIcon,
    IonItem,
    IonInput,
    IonBackButton,
    IonNote,
    IonFooter,
    IonSpinner,
    IonButton,
    Message,
    IonSelect,
    IonSelectOption]
})
export class AuthFieldsPage implements OnInit {


  private api = inject(ApiService)

  userPrivacy: UserPrivacy
  groupFields: GroupField[] = []
  group: Group
  firebaseUid: string
  gprivacyConsentUser: GroupPrivacyConsentUser[]

  regexReplace: RegExp = new RegExp(/[^0-9\/]/g)
  regex: RegExp = new RegExp(/^\d{1,2}\/?\d{0,2}\/?\d{0,4}$/g)

  saving = false
  formError = false

  fromMenu = false

  constructor(
    public modalController: ModalController,
    //public nav: IonNav
  ) {
    addIcons({ closeOutline, informationCircleOutline, alertCircle, checkmarkCircle });
  }

  ngOnInit() {
  }

  checkValidField(gf: GroupField) {
    if (gf.required && gf.value != "") {
      gf.valid = true
      gf.error = undefined
    }
    else if (gf.required && !gf.value) {
      gf.valid = false
      gf.error = "Devi inserire " + gf.label
    }
    else if (!gf.required) {
      gf.valid = true
      gf.error = undefined
    }
    else {
      gf.valid = false
      gf.error = undefined
    }
  }

  checkValidGender(gf: GroupField) {
    console.log("checkValidGender", gf)
    if (gf.required && !gf.value) {
      gf.valid = false
      gf.error = "Devi selezionare il genere"
    } else {
      gf.valid = true
      gf.error = undefined
    }
  }

  checkValidYear(gf: GroupField) {
    if (gf.required && !gf.value) {
      gf.valid = false
      gf.error = "Devi inserire " + gf.label
      return
    }

    if (!gf.value) {
      // not required and empty → valid
      gf.valid = true
      gf.error = undefined
      return
    }

    const year = Number(gf.value)
    const currentYear = new Date().getFullYear()

    if (isNaN(year) || !/^\d{4}$/.test(gf.value)) {
      gf.valid = false
      gf.error = "Anno non valido"
    }
    else if (year > currentYear) {
      gf.valid = false
      gf.error = "L'anno non può essere nel futuro"
    }
    else {
      gf.valid = true
      gf.error = undefined
    }
  }

  checkMinimumAgeDate(gf: GroupField) {
    if (gf.required && !gf.value) {
      gf.valid = false
      gf.error = "Devi inserire " + gf.label
      return
    }

    if (!gf.value) {
      gf.valid = true
      gf.error = undefined
      return
    }

    let value = String(gf.value).replace(/[^0-9-]/g, '')

    if (value.length >= 2 && value[2] !== '-') {
      value = value.slice(0, 2) + '-' + value.slice(2);
    }

    if (value.length >= 5 && value[5] !== '-') {
      value = value.slice(0, 5) + '-' + value.slice(5);
    }

    gf.value = value

    const regex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/
    if (!regex.test(value)) {
      gf.valid = false
      gf.error = "La data non è corretta (gg-mm-yyyy)"
      return
    }

    const [day, month, year] = value.split('-').map(Number)
    const parsedDate = new Date(year, month - 1, day)
    const isValidDate =
      parsedDate.getFullYear() === year &&
      parsedDate.getMonth() === month - 1 &&
      parsedDate.getDate() === day

    if (!isValidDate) {
      gf.valid = false
      gf.error = "La data non è corretta (gg-mm-yyyy)"
      return
    }

    const today = new Date()
    const minimumBirthDate = new Date(today.getFullYear() - 14, today.getMonth(), today.getDate())

    if (parsedDate > minimumBirthDate) {
      gf.valid = false
      gf.error = "Devi avere almeno 14 anni"
    }
    else {
      gf.valid = true
      gf.error = undefined
    }
  }

  checkCapIt(gf: GroupField) {
    if (gf.value.length == 5) {
      gf.error = undefined
      gf.valid = true
    } else {
      gf.error = "Formato non valido"
      gf.valid = false
    }
  }

  checkFiscalCode(gf: GroupField) {

    const fc = (gf.value as string).toUpperCase()
    if (!CodiceFiscale.check(fc)) {
      gf.error = "Formato non valido"
      gf.valid = false
    } else {
      gf.error = undefined
      gf.valid = true
    }
  }

  checkDateField(gf: GroupField) {

    let value = gf.value

    value = value.replace(this.regexReplace, '')

    if (value.length >= 2 && value[2] !== '/') {
      value = value.slice(0, 2) + '/' + value.slice(2);
    }


    if (value.length >= 5 && value[5] !== '/') {
      value = value.slice(0, 5) + '/' + value.slice(5);
    }


    gf.value = value

    // Regular expression to match the date format DD/MM/YYYY
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

    // Test the date string against the regular expression
    if (!regex.test(value)) {
      gf.error = "La data non è corretta (gg/mm/aaaa)"
      gf.valid = false
      return
    }

    gf.error = undefined

    // Parse the date components
    const [day, month, year] = value.split('/').map(Number);

    // Create a date object with the parsed components
    const parsedDate = new Date(year, month - 1, day);

    // Check if the parsed date components match the input date
    gf.valid = parsedDate.getFullYear() === year &&
      parsedDate.getMonth() === month - 1 &&
      parsedDate.getDate() === day;



  }

  checkFNOMCEOInput(gf: GroupField) {
    if (gf.required && gf.value > 0) {
      gf.valid = true
      gf.error = undefined
    } else {
      gf.valid = false
      gf.error = "L'ID non è valido"
    }
  }

  formIsValid() {
    if(!this.groupFields) return true
    for (const gf of this.groupFields) {
      if (!gf.valid) {
        if (gf.required) {
          return false
        }
      }
    }

    return true
  }

  async updatePrivacy() {



    try {
      const hasFNOMCEO = this.groupFields.filter((gf) => gf.type === 3).length > 0
      if (hasFNOMCEO) {
        const nome = this.groupFields.filter((gf) => gf.label.toLowerCase() === "nome")[0].value
        const cognome = this.groupFields.filter((gf) => gf.label.toLowerCase() === "cognome")[0].value
        const data = this.groupFields.filter((gf) => gf.type === 1)[0].value as string
        const gfiscrizione = this.groupFields.filter((gf) => gf.type === 3)[0]
        const niscrizione = gfiscrizione.value
        console.log("niscrizione", niscrizione)

        //const dataFormatted = this.isoToDDMMYYYY(data)
        const res = await this.api.searchFNOMCEO(nome, cognome, data.trim())
        console.log(res)
        let valid = false
        for (const r of res.results) {
          const parts = r.split(" ")
          for (const p of parts) {
            const numberPattern = /^-?\d+(\.\d+)?$/
            if (numberPattern.test(p)) {
              const resultNumber = Number(p)
              if (resultNumber == niscrizione) {
                valid = true
                break
              }
            }
          }
        }

        if (valid) {
          console.log("num iscrizione valida!")
        } else {
          console.log("num iscrizione NON valida!")
          this.api.showToast("Il numero di iscrizione all'albo non è valido", "alert")
          gfiscrizione.valid = false
          this.saving = false
          return
        }
      }

      if (this.userPrivacy) {
        await this.api.updateUserPrivacy(this.userPrivacy)
      }

      await this.api.setUserGroupData(this.firebaseUid, this.group.gid, this.groupFields)
      if (this.group.custom_privacy && this.gprivacyConsentUser) {
        for (const gpcu of this.gprivacyConsentUser) {
          await this.api.setGroupPrivacyConsentUser(gpcu)
        }
      }

      if (this.group.gid == 1) {
        const nnfield = this.groupFields.filter((gf) => gf.label === "Nickname")
        if (nnfield.length > 0) {
          await FirebaseAuthentication.updateProfile({
            displayName: nnfield[0].value
          })
        }
      }

      const topm = await this.modalController.getTop()
      if (!!topm) {
        console.log("AuthFieldsPage modal on top", topm.component.toString())
      }

      this.modalController.dismiss({updated: true})
    } catch (error) {
      console.log("Error", error)
      this.api.showToast("Si è verificato un errore, riprova più tardi", "alert")
    }

    this.saving = false


  }
}
